import React from "react";
import { HotkeysTarget2 } from "@blueprintjs/core";


function EditHK({handleEdit}) {

    const hotkeys = [
        {
            combo: "e",
            global: true,
            label: "Edit",
            onKeyDown: handleEdit,
        },
        // {
        //     combo: "cmd + e",
        //     global: true,
        //     label: "Edit",
        //     onKeyDown: handleEdit,
        // },
    ]

    return (
        <HotkeysTarget2 hotkeys={hotkeys}>
                {({ handleKeyDown, handleKeyUp }) => (
                    <div onKeyDown={handleKeyDown} onKeyUp={handleKeyUp}>
                        
                    </div>
                )}
        </HotkeysTarget2>
    )
}

export default EditHK